import {css} from '@emotion/react'
import styled from '@emotion/styled'

import {Grid} from '@daedalus/atlas/src/components/designSystem/helpers/Grid'

export const OFFER_MIN_HEIGHT = 52

export const OfferWrapper = styled(Grid)(
  ({theme}) => css`
    width: 100%;
    background-color: ${theme.colors.background.neutral.c000};
    padding: ${theme.layout.spacing.s300}px ${theme.layout.spacing.s400}px;
    min-height: ${OFFER_MIN_HEIGHT}px;
  `
)

export const OfferContainer = styled('div')(
  `
    width: 100%;
  `
)

export const ProviderWrapper = styled(Grid)`
  height: 20px;
`

export const PriceWrapper = styled(Grid)(
  ({theme}) => css`
    padding-left: ${theme.layout.spacing.s300}px;
  `
)

export const IconWrapper = styled('div')(
  ({theme}) => css`
    /* @mirror */
    margin-left: ${theme.layout.spacing.s200}px;
    color: ${theme.colors.content.neutral.c600};
  `
)

export const OfferListWrapper = styled(Grid)(
  ({theme}) => css`
    padding-top: ${theme.layout.spacing.s300}px;
    width: 100%;
  `
)
